module.exports = __webpack_public_path__ + "static/media/share.29332dd2.svg";